  <div class="sidebar-modern d-flex  shadow border-top"
    :class="{ 'd-none': !is_demo_domain, collapsed: is_collapsed }">

    <!-- Collapse Toggle Button -->
    <button
      class="collapse-toggle position-fixed align-items-center shadow border border-secondary rounded-end"
      @click.stop="toggle_collapse"
      @mousedown.prevent
      type="button"
      aria-label="Toggle sidebar"
    >
      <div :class="{ 'rotated': settings_menu_open }">
        <!-- Chevron Right -->
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="9 18 15 12 9 6"/>
        </svg>
      </div>
    </button>

    <!-- Logo Section -->
    <div class="sidebar-header">
      <div class="logo-container d-flex d-none">
        <img :src="styleConfig.logo" alt="AIC ONE" class="main-logo">
      </div>
    </div>

    <!-- App Launcher -->
  <div class="app-launcher-section">
    <div class="dropdown">
      <button
        class="app-launcher-btn d-flex"
        type="button"
        id="app_launcher_btn"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <!-- Grid / waffle icon -->
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="launcher-icon">
          <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/>
          <rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/>
        </svg>
        <span class="launcher-text">My Apps</span>
      </button>

      <div class="dropdown-menu app-grid-dropdown bg-white" aria-labelledby="app_launcher_btn">
        <div class="app-grid bg-white">
          <a v-if="!demo_allowed_apps || demo_allowed_apps.includes('orcaa')" class="app-item d-flex" @click="launch_platform('orcaa')">
            <div class="app-icon-wrapper d-flex rounded-4">
              <img :src="styleConfig.orcaa_icon" alt="Orcaa">
            </div>
          </a>

          <a v-if="!demo_allowed_apps || demo_allowed_apps.includes('workflow')" class="app-item d-flex" @click="launch_platform('workflow')">
            <div class="app-icon-wrapper d-flex rounded-4">
              <img :src="styleConfig.workflows_icon" alt="Workflows">
            </div>
          </a>

          <a v-if="!demo_allowed_apps || demo_allowed_apps.includes('engagenet')" class="app-item d-flex" @click="launch_platform('engagenet')">
            <div class="app-icon-wrapper d-flex rounded-4">
              <img :src="styleConfig.engagenet_icon"
                :alt="is_internal_suite ? 'IC Workbook' : 'Engagenet'">
            </div>
          </a>

          <a v-if="!demo_allowed_apps || demo_allowed_apps.includes('x-verdict')" class="app-item d-flex" @click="launch_platform('x-verdict')">
            <div class="app-icon-wrapper d-flex rounded-4">
              <img :src="styleConfig.xverdict_icon" alt="X-Verdict">
            </div>
          </a>

          <a v-if="!demo_allowed_apps || demo_allowed_apps.includes('proba')" class="app-item d-flex" @click="launch_platform('proba')">
            <div class="app-icon-wrapper d-flex rounded-4">
              <img :src="styleConfig.proba_icon" alt="Analytics">
            </div>
          </a>

           <a v-if="!demo_allowed_apps || demo_allowed_apps.includes('complyon')" class="app-item d-flex" @click="launch_platform('complyon')">
            <div class="app-icon-wrapper d-flex rounded-4">
              <img :src="styleConfig.complyon_icon" alt="Complyon">
            </div>
          </a>

          <a v-if="!demo_allowed_apps || demo_allowed_apps.includes('complyon_onboard')" class="app-item onboardid-app d-flex" @click="launch_platform('complyon_onboard')">
            <div class="app-icon-wrapper d-flex rounded-4">
              <img :src="styleConfig.complyon_onboard_icon" alt="OnboardID">
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>


    <!-- Main Navigation -->
    <nav class="sidebar-nav">

      <router-link to="/home" class="nav-item d-flex" active-class="active">
        <div class="nav-icon d-flex">
          <!-- Home -->
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
            <polyline points="9 22 9 12 15 12 15 22"/>
          </svg>
        </div>
        <span class="nav-label">Home</span>
      </router-link>

      <router-link to="/chat" class="nav-item d-flex d-none" active-class="active">
        <div class="nav-icon d-flex">
          <!-- Message Square -->
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
          </svg>
        </div>
        <span class="nav-label">One Chat</span>
      </router-link>

      <router-link to="/create" class="nav-item d-flex" active-class="active">
        <div class="nav-icon d-flex">
          <!-- Folder Open -->
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/>
          </svg>
        </div>
        <span class="nav-label">Projects &amp; Workspaces</span>
      </router-link>

      <router-link to="/drive" class="nav-item d-flex" active-class="active">
        <div class="nav-icon d-flex ">
          <!-- Database -->
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <ellipse cx="12" cy="5" rx="9" ry="3"/>
            <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"/>
            <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"/>
          </svg>
        </div>
        <span class="nav-label">Data &amp; Storage</span>
      </router-link>

      <router-link to="/audit_trail" class="nav-item d-flex" active-class="active">
        <div class="nav-icon d-flex">
          <!-- Shield -->
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
          </svg>
        </div>
        <span class="nav-label">Governance &amp; Security</span>
      </router-link>

      <router-link to="/support" class="nav-item d-flex d-none" active-class="active">
        <div class="nav-icon d-flex">
          <!-- Life Buoy -->
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"/>
            <circle cx="12" cy="12" r="4"/>
            <line x1="4.93" y1="4.93" x2="9.17" y2="9.17"/>
            <line x1="14.83" y1="14.83" x2="19.07" y2="19.07"/>
            <line x1="14.83" y1="9.17" x2="19.07" y2="4.93"/>
            <line x1="4.93" y1="19.07" x2="9.17" y2="14.83"/>
          </svg>
        </div>
        <span class="nav-label">Support &amp; Community</span>
      </router-link>

      <!-- Settings with Expandable Submenu -->
      <div v-if="is_admin" class="nav-item-wrapper">
        <a
          class="nav-item d-flex has-submenu"
          @click="toggle_settings_menu"
        >
          <div class="nav-icon d-flex">
            <!-- Settings / Gear -->
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="3"/>
              <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06
                a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09
                A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06
                A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09
                A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06
                A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09
                a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06
                A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09
                a1.65 1.65 0 0 0-1.51 1z"/>
            </svg>
          </div>
          <span class="nav-label">Settings</span>
          <div class="submenu-arrow" :class="{ 'rotated': settings_menu_open }">
            <!-- Chevron Down -->
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="6 9 12 15 18 9"/>
            </svg>
          </div>
        </a>

        <div class="nav-submenu" :class="{ 'open': settings_menu_open }">

          <router-link to="/profile" class="submenu-item d-flex" active-class="active"
            @click.native="close_settings_menu_on_mobile">
            <div class="submenu-icon d-flex">
              <!-- User -->
              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                <circle cx="12" cy="7" r="4"/>
              </svg>
            </div>
            <span class="nav-label submenu-label-mobile">Profile</span>
          </router-link>

          <router-link to="/permission" class="submenu-item d-flex" active-class="active"
            @click.native="close_settings_menu_on_mobile">
            <div class="submenu-icon d-flex">
              <!-- Lock -->
              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
              </svg>
            </div>
            <span class="nav-label submenu-label-mobile">Permissions</span>
          </router-link>

          <router-link to="/role" class="submenu-item d-flex" active-class="active"
            @click.native="close_settings_menu_on_mobile">
            <div class="submenu-icon d-flex">
              <!-- Briefcase / Tag -->
              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/>
                <line x1="7" y1="7" x2="7.01" y2="7"/>
              </svg>
            </div>
            <span class="nav-label submenu-label-mobile">Roles</span>
          </router-link>

          <router-link to="/settings" class="submenu-item d-flex" active-class="active"
            @click.native="close_settings_menu_on_mobile">
            <div class="submenu-icon d-flex">
              <!-- Users -->
              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                <circle cx="9" cy="7" r="4"/>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
              </svg>
            </div>
            <span class="nav-label submenu-label-mobile">Users</span>
          </router-link>

          <router-link to="/access_control" class="submenu-item d-flex d-none" active-class="active"
            @click.native="close_settings_menu_on_mobile">
            <div class="submenu-icon d-flex">
              <!-- Key -->
              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5
                  m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"/>
              </svg>
            </div>
            <span class="nav-label submenu-label-mobile">Access Control</span>
          </router-link>

          <router-link to="/system_configure" class="submenu-item d-flex" active-class="active"
            @click.native="close_settings_menu_on_mobile">
            <div class="submenu-icon d-flex">
              <!-- Sliders -->
              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="4" y1="21" x2="4" y2="14"/><line x1="4" y1="10" x2="4" y2="3"/>
                <line x1="12" y1="21" x2="12" y2="12"/><line x1="12" y1="8" x2="12" y2="3"/>
                <line x1="20" y1="21" x2="20" y2="16"/><line x1="20" y1="12" x2="20" y2="3"/>
                <line x1="1" y1="14" x2="7" y2="14"/><line x1="9" y1="8" x2="15" y2="8"/>
                <line x1="17" y1="16" x2="23" y2="16"/>
              </svg>
            </div>
            <span class="nav-label submenu-label-mobile">System Configure</span>
          </router-link>

          <router-link to="/superset_manager" class="submenu-item d-flex d-none" active-class="active"
            @click.native="close_settings_menu_on_mobile">
            <div class="submenu-icon d-flex">
              <!-- Layers -->
              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polygon points="12 2 2 7 12 12 22 7 12 2"/>
                <polyline points="2 17 12 22 22 17"/>
                <polyline points="2 12 12 17 22 12"/>
              </svg>
            </div>
            <span class="nav-label submenu-label-mobile">Manage Superset</span>
          </router-link>

          <router-link to="/main_settings" class="submenu-item d-flex" active-class="active"
            @click.native="close_settings_menu_on_mobile">
            <div class="submenu-icon d-flex">
              <!-- Tool / Wrench -->
              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77
                  a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91
                  a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>
              </svg>
            </div>
            <span class="nav-label submenu-label-mobile">General Settings</span>
          </router-link>

        </div>

        <div
          v-if="settings_menu_open"
          class="submenu-overlay d-block d-sm-none"
          @click="close_settings_menu_on_mobile"
        ></div>
      </div>

    </nav>

    <!-- Logout Section -->
    <div class="sidebar-footer">
      <button class="logout-btn d-flex" @click="logout()">
        <div class="nav-icon">
          <!-- Log Out -->
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
            <polyline points="16 17 21 12 16 7"/>
            <line x1="21" y1="12" x2="9" y2="12"/>
          </svg>
        </div>
        <span class="nav-label">Logout</span>
      </button>
    </div>
  </div>